/* SandyClair — barra de progreso de envío gratis (carrito) */
(function () {
  'use strict';

  function updateBars(cart) {
    document.querySelectorAll('[data-sc-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) return;

      // Envío gratis siempre: nunca «te faltan X €»; con el carrito vacío, que lo diga claro
      if (bar.getAttribute('data-siempre') === 'true') {
        var fillS = bar.querySelector('[data-sc-shipping-bar-fill]');
        var textS = bar.querySelector('[data-sc-shipping-bar-text]');
        if (fillS) fillS.style.width = '100%';
        if (textS) textS.textContent = bar.getAttribute('data-text-siempre') || '';
        bar.classList.add('is-complete');
        return;
      }

      var remaining = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      var fill = bar.querySelector('[data-sc-shipping-bar-fill]');
      var text = bar.querySelector('[data-sc-shipping-bar-text]');

      if (fill) fill.style.width = pct + '%';

      if (text) {
        if (remaining <= 0) {
          text.textContent = bar.getAttribute('data-text-success') || '';
          bar.classList.add('is-complete');
        } else {
          var amount = (remaining / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
          var template = bar.getAttribute('data-text-progress') || '';
          text.textContent = template.replace('{{ amount }}', amount);
          bar.classList.remove('is-complete');
        }
      }
    });
  }

  function refresh() {
    if (!document.querySelector('[data-sc-shipping-bar]')) return;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js')
      .then(function (response) { return response.json(); })
      .then(updateBars)
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  });
})();
